import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';

import { Container, Scroll, Anchor, Title, Grid, ItemImage, ItemContainer } from './styles';

const Props = {
  href: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  columns: PropTypes.number.isRequired,
};

function TemplateItem({ src, alt, href }) {
  const imageRef = useRef();
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    function handleImageError() {
      setHasError(true);
    }

    if (imageRef.current) {
      imageRef.current.addEventListener('error', handleImageError);
    }

    return () => {
      if (imageRef.current) {
        imageRef.current.removeEventListener('error', handleImageError);
      }
    };
  }, []);

  if (hasError) {
    return null;
  }

  return (
    <Link href={href} passHref>
      <ItemContainer>
        <ItemImage ref={imageRef} src={src} alt={alt} />
      </ItemContainer>
    </Link>
  );
}

export default function TemplatesGrid({ href, title, columns, children }) {
  return (
    <Container>
      <Link href={href} passHref>
        <Anchor>
          <Title>{title}</Title>
        </Anchor>
      </Link>
      <Scroll>
        <Grid columns={columns}>{children}</Grid>
      </Scroll>
    </Container>
  );
}

TemplatesGrid.propTypes = Props;
TemplatesGrid.Item = TemplateItem;
